import { type SiteIsoEnum, type SiteLangEnum } from "@kunduz/utility-common";

/**
 * we store i18nextlocale and api country relation here
 */
export const localeData: ILocaleInfo[] = [
  {
    apiId: 1,
    iso: "TR",
    i18nextLocale: "tr-TR",
  },
  {
    apiId: 1,
    iso: "TR",
    i18nextLocale: "tr",
  },
  {
    apiId: 3,
    iso: "US",
    i18nextLocale: "en-US",
  },
  {
    apiId: 3,
    iso: "US",
    i18nextLocale: "en",
  },
  {
    apiId: 5,
    iso: "AE",
    i18nextLocale: "en-AE",
  },
  {
    apiId: 6,
    iso: "EG",
    i18nextLocale: "en-EG",
  },
];

export function getLocale(filter: {
  i18nextLocale?: SiteLangEnum;
  apiId?: number;
}): ILocaleInfo | undefined {
  let result = localeData;

  if (filter.i18nextLocale) {
    result = result.filter(
      (singleLocaleData) =>
        singleLocaleData.i18nextLocale === filter.i18nextLocale,
    );
  }

  if (filter.apiId) {
    result = result.filter(
      (singleLocaleData) => singleLocaleData.apiId === filter.apiId,
    );
  }

  return result[0];
}

export interface ILocaleInfo {
  apiId: number;
  iso: SiteIsoEnum;
  i18nextLocale: SiteLangEnum;
}
